/**
 * Single source of truth for pathnames reachable WITHOUT an authenticated
 * session.
 *
 * Both the middleware proxy (`proxy.ts`) and the dead-session recovery
 * skip-list (`lib/auth/session-expiry.ts`) consume this predicate so they cannot
 * drift apart: a page the proxy serves to anonymous visitors must never trigger
 * a "session expired" redirect just because an authenticated background SWR read
 * on that page happened to 401.
 *
 * Note: `/verify-email` is intentionally NOT listed here — it requires a session
 * cookie (see `proxy.ts`). Callers that also want to treat it as auth-adjacent
 * handle it separately.
 */
export function isPublicPathname(pathname: string): boolean {
  const isPublicBoverksnyttPathname =
    pathname === '/boverksnytt-public' ||
    pathname === '/boverksnytt-public/' ||
    pathname === '/boverksnytt' ||
    pathname.startsWith('/boverksnytt/');

  return (
    pathname === '/login' ||
    pathname === '/signup' ||
    pathname.startsWith('/signup/') ||
    pathname === '/register' ||
    pathname === '/forgot-password' ||
    pathname === '/reset-password' ||
    pathname.startsWith('/auth/invitation/') ||
    pathname.startsWith('/canvas/share/') ||
    pathname.startsWith('/join/') ||
    pathname.startsWith('/dev/') ||
    pathname.startsWith('/downloads') ||
    pathname === '/learn' ||
    pathname === '/whats-new' ||
    isPublicBoverksnyttPathname ||
    pathname === '/brand/boverket.png' ||
    pathname === '/privacy-policy' ||
    pathname === '/terms-of-service'
  );
}
